<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="flex flex-col justify-between gap-5 md:flex-row">
        <div class="relative flex items-center">
            <button
                class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
                (click)="goback()">
                <mat-icon
                    class="w-[5px] h-[3px] mr-[1px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                    svgIcon="icons:arrow-icon">
                </mat-icon>
            </button>
            <h1 class="text-black title-6 md:title-3">Plantillas de pagarés</h1>
        </div>
        <button class="flex items-center self-end gap-3" routerLink="editor-plantilla">
            <p class="text-primary-blue-01 text-button-12px">AGREGAR PLANTILLA</p>
            <mat-icon class="w-[9px] h-[9px] min-w-[9px] min-h-[9px] text-primary-blue-01" svgIcon="icons:plantillas-icon"> </mat-icon>
        </button>
    </div>

    <div class="flex flex-wrap py-5 mt-5 md:mt-10 gap-x-7 gap-y-5">
        <div
            *ngFor="let plantilla of plantillas"
            class="rounded-xl w-full md:w-[223px] h-[112.04px] shadow-[0_5px_15px_2px_rgba(0,0,0,0.1)] flex flex-col justify-between pl-6 pr-4 py-6">
            <div class="flex justify-between w-full">
                <p class="font-extrabold paragraph-4 text-primary-black-01">
                    {{ plantilla.VALOR }}
                </p>
                <mat-icon class="w-[20.63px] h-[26.26px] min-w-[20.63px] min-h-[26.26px] text-primary" svgIcon="icons:pagares-icon"> </mat-icon>
            </div>
            <p class="font-extrabold cursor-pointer paragraph-5 text-primary-blue-01" [routerLink]="['editor-plantilla', plantilla.VALOR]">
                Editar plantilla
            </p>
        </div>
    </div>
</main>
